module.exports = __webpack_public_path__ + "img/rs.95e1357c.svg";